export default "__VITE_PUBLIC_ASSET__bfb874e5__"